import Vue from "vue";
import Component from "vue-class-component";
import { Order, Organization } from "@/types/order";
import { Product } from "@/api/product";
import OrderDetailList from "@/components/OrderDetailList/OrderDetailList.vue";
import REQ_URL from "@/consts/req-url";
import {
  SettlementAccount,
  SettlementAccounts,
  SettlementAccountValue,
} from "@/types/settlement-account";
import { Getter } from "vuex-class";

@Component({
  components: {
    OrderDetailList,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if ((vm as OrderDetail).$route.params.order)
        (vm as OrderDetail).order = JSON.parse(
          (vm as OrderDetail).$route.params.order
        );
      else (vm as OrderDetail).setOrder(vm.$route.params.id);
    });
  },
  beforeRouteUpdate(this: OrderDetail, to, from, next) {
    this.$nextTick(() => {
      if (this.$route.params.order)
        this.order = JSON.parse(this.$route.params.order);
      else this.setOrder(this.$route.params.id);
      this.scroll();
    });
    next();
  },
})
export default class OrderDetail extends Vue {
  @Getter("settlementAccounts") settlementAccounts!: SettlementAccounts;
  selectedOrganization: SettlementAccountValue | null = null;
  order: Order | null = null;
  loading = false;
  products: Product[] = [];
  viewListMode: string = "list";
  get compViewListMode() {
    return this.$vuetify.breakpoint.xsOnly ? "grid" : this.viewListMode;
  }
  get downloadUrl() {
    return REQ_URL.DOWNLOAD_ORDER;
  }
  async setOrder(id: string) {
    this.loading = true;
    try {
      let data = await this.$fetch<Order>(
        `${REQ_URL.GET_ORDER}?id=${this.$route.params.id}`
      );
      if (data.body) this.order = data.body;
      else throw new Error(data.error);
    } catch (error) {
      console.log(error);
      return false;
    }
    if (this.order.Organization) {
      let org = this.settlementAccounts.filter(
        (acc) => acc.value.Имя_1с === this.order!.Organization!.Name
      )[0];
      if (org) this.selectedOrganization = org.value;
      else this.selectedOrganization = this.settlementAccounts[0].value;
    } else this.selectedOrganization = this.settlementAccounts[0].value;
    return true;
  }
  scroll() {
    let tb = document.getElementById("detail");
    if (tb) {
      this.$vuetify.goTo(tb, {
        duration: 300,
      });
    }
  }
  mounted() {
    setTimeout(() => {
      this.scroll();
    }, 300);
  }
}
